module.exports = "\r\n<div class=\"overflow-xh paddingh10\">\r\n\t<div class=\"clearfix marginr-n10\">\r\n\t\t<slot></slot>\r\n\t</div>\r\n</div>\r\n";